import type {
	InlineMessageDesignTokens,
	InlineMessageTokenSections,
} from '@openng/optimus-ui-themes/types/inlinemessage';

export const colorScheme: InlineMessageTokenSections.ColorScheme = {
	light: {
		info: {
			background: 'color-mix(in srgb, {primary.50}, transparent 5%)',
			borderColor: '{primary.200}',
			color: '{primary.600}',
			shadow: '0px 4px 8px 0px color-mix(in srgb, {primary.500}, transparent 96%)',
		},
	},
};

export default {
	colorScheme,
} satisfies InlineMessageDesignTokens;
